
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";
import ModalOdonto from "./ModalOdonto.vue"

@Component({
	name: "Odontograma",
	components: {ModalOdonto}
})

export default class Odontograma extends Vue {
	@Prop() paciente_id!: number
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();


	
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	tipo_denticion = []
	denticion_alta = []
	denticion_baja = []
	pieza = null
	swModal = false
	baseURLImage = `${process.env.VUE_APP_URL_BASE}`;
	// get paciente() {
	// 	return this.consultorioStore.paciente;
	// }
	mounted() {
		this.getTipoDenticion();
		this.listar()
		this.consultorioService.otrosTratamientos();
	}
	get otros_tratamientos() {
		return this.consultorioStore.otros_tratamientos;
	}
	get detalle_odontograma() {
		return this.consultorioStore.detalle_odontograma;
	}
	async getTipoDenticion() {
		await http.get('tipos-denticion',{params: {tipo_denticion_id: 1}}).subscribe({
			next: (response:AxiosResponse) => {
				this.denticion_alta = response.data.denticion_alta;
				this.denticion_baja = response.data.denticion_baja;
			},
		})
	}
	async listar(){
		this.consultorioService.getDetalleOdontograma(this.paciente_id);
	}
	abrirModal(pieza:any) {
		this.swModal = true;
		this.pieza = pieza

	}
	mostrarTratamientoImagen(pieza:number) {
		console.log(pieza)
		let src = ''
		let detalles = this.detalle_odontograma.filter(el => el.pieza_dental_id == pieza && el.otro_tratamiento.en_pieza == true)
		// if(detalle && detalle.otro_tratamiento.en_pieza == true){
		// 	src = `${this.baseURLImage}storage/piezas/${detalle.otro_tratamiento.imagen}`
		// }
		return detalles
	}
	mostrarCaras(pieza:number) {
		// let caras = []
		let detalle_caras = this.detalle_odontograma.filter(el => el.pieza_dental_id == pieza && el.otro_tratamiento.en_pieza == false)
		// if(detalle_caras){
		// 	caras = detalle_caras.detalle_odonto_caras
		// }
		let caras = detalle_caras.flatMap(({detalle_odonto_caras}) => detalle_odonto_caras)
		return caras
	}
	mostrarCaraReal(pieza: number, cara: string){
		if(pieza > 11 && pieza <= 18) {
			if(cara == 'vestibular.png') return 'lingual.png';
			if(cara == 'paladino.png') return 'vestibular.png';
			if(cara == 'distal.png') return cara;
			if(cara == 'mesial.png') return cara;
		}
		if(pieza > 20 && pieza <= 28) {
			if(cara == 'mesial.png') return 'distal.png';
			if(cara == 'distal.png') return 'mesial.png';
			if(cara == 'vestibular.png') return 'lingual.png';
			if(cara == 'paladino.png') return 'vestibular.png';
		}
		// if(cara !== 'mesial.png' && cara !== 'distal.png') {
		// 	return cara;
		// }
		if(pieza > 40 && pieza <= 48){
			return cara;
		}
		if(pieza >30 && pieza <= 38){
			if(cara == 'mesial.png') return 'distal.png';
			if(cara == 'distal.png') return 'mesial.png';
			if(cara == 'lingual.png') return cara;
			if(cara == 'vestibular.png') return cara;
		}
		if(cara == 'oclusal.png') return cara;
	}

	eliminar(detalle:any) {
      Alert.confirm(`Se va a eliminar el detalle ${detalle.otro_tratamiento.nombre} del odontograma`, 'Eliminar detalle odontograma?').then(res => {
        if (res.isConfirmed) {
          this.consultorioService.eliminarDetalleOdontograma(detalle.id);
          this.listar()
        }
      })
    }
	getColor(color:string){
		let valor = '';
		switch (color) {
			case 'ROJO':
				valor = 'red'
				break;
			case 'AZUL':
				valor = 'primary'
				break;
			case 'AMARILLO':
				valor = 'yellow'
				break;
			case 'NEGRO':
				valor = 'black'
				break;
			case 'VERDE':
				valor = 'green'
				break;
			case 'LILA':
				valor = 'indigo'
				break;
			case 'VERDEOSCURO':
				valor = '#1B5E20'
				break;
			case 'NARANJA':
				valor = 'orange'
				break;
			case 'DORADO':
				valor = '#FFC400'
				break;
			case 'AZULADO':
				valor = '#C68346'
				break;
			case 'ROSA':
				valor = '#F8BBD0'
				break;
			default:
				break;
		}
		return valor;
	}
	// guardar() {
	// 	if (!this.$refs.form.validate()) {
	// 		Alert.warning(`Lene todos los campos obligatorios (*)`)
	// 		return;
	// 	}
	// 	if (!this.swEditar) {
	// 		Alert.confirm(`Se realizará el registro del paciente ${this.paciente.nombre} ${this.paciente.apellidos}`, 'Registrar nueva Paciente?').then(async result => {
	// 			if (result.isConfirmed) {
	// 				await this.consultorioService.registrarPaciente(this.paciente).then(response => {

	// 					this.limpiar()
	// 					this.close()
	// 					//this.listar()
	// 				})

	// 			}
	// 		})
	// 	} else {
	// 		Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
	// 			if (result.isConfirmed) {
	// 				await this.consultorioService.editarVenta(this.venta)
	// 				this.limpiar()
	// 			}
	// 		})
	// 	}

	// }
	
}

